import { DATA_REQUEST } from './constants'

const fetchData = (userId) => ({
  type: DATA_REQUEST.INITIATE,
  payload: { userId },
})
export const fetchDataSuccess = (data) => ({
  type: DATA_REQUEST.SUCCESS,
  payload: { data },
})
const fetchDataCancel = () => ({ type: DATA_REQUEST.CANCEL })
export const fetchDataError = (error) => ({ type: DATA_REQUEST.ERROR, error })

export default {
  // to props
  fetchData,
  fetchDataCancel,
}
